import { AxiosResponse } from 'axios'

interface ErrorResponse {
  error: string
  message: string
}

const isErrorResponse = (data: { error?: unknown; message: string }): data is ErrorResponse => {
  return Boolean(!data || (data?.error && data?.message))
}

const responseOkGuard = (response: AxiosResponse): AxiosResponse => {
  if (!response?.status) {
    throw response
  }

  if (isErrorResponse(response.data)) {
    throw response
  }

  if (response.status < 200 || response.status >= 300) {
    throw response
  }

  return response
}

export default responseOkGuard
